import React, { useEffect, useState } from "react";
import VideoViewer from "@base/lib/VideoViewer";
import { loadImage, loadImages } from 'base/utils/getPicUrl';
import ImagesListSwiper from "./ImagesListSwiper";
import ImageZoomViewer from "./ImageZoomViewer";
import { transImageSrc } from 'base/utils/trans-path';
import PreloadResources from '@base/lib/PreloadResources';
import styles from "./index.module.less";
import type { IAsset } from 'mod/feature/interface'
import delay from 'base/utils/delay'

interface IProps {
    aspectRatio?: number; // 容器高宽比
    thumbImageSize?: number;
    bigPicRef?: React.RefObject<HTMLDivElement>;
    imagesList: IAsset[];
}

const IMAGE_BIG_WIDTH = 700;


const ImagesLightbox: React.FC<IProps> = (props) => {
    const {
        aspectRatio = 1,
        imagesList,
        thumbImageSize,
        bigPicRef
    } = props;

    const [selectedItem, setSelectedItem] = useState<IAsset | undefined>();

    // 加载图片列表
    const handlePreLoadImages = () => {
        loadImages(imagesList
            .filter(img => !!img.picUrl) // 排除不是图片的
            .map((img) => transImageSrc(img?.picUrl, thumbImageSize, 2 ))
        )
    }
    const preloadImageSrc = imagesList.length ? transImageSrc(imagesList[0].picUrl, thumbImageSize, 2) : '';

    // 切换展示图
    const onChangeShowImage = async (e: IAsset) => {
        if (!e.videoUrl) {
            // 没有视频 图片加载
            loadImage(transImageSrc(e?.picUrl, IMAGE_BIG_WIDTH, 2))
        } else {
            // 两个视频切换无用 先置空
            setSelectedItem(undefined);
            await delay(1);
        }
        setSelectedItem(e)
    }

    useEffect(() => {
        if (!imagesList?.length) {
            return
        }
        if (document?.readyState == 'complete') {
            handlePreLoadImages()
        } else {
            if (typeof window !== 'undefined') {
                window.onload = function () {
                    handlePreLoadImages()
                }
            }
        }
        setSelectedItem(imagesList?.[0])
    }, [imagesList])

    return (
        <>
            {/*预加载主图*/}
            <PreloadResources list={[preloadImageSrc]}/>
            <div className={`${styles.lightboxWrap} flex`}>
                <div className={`${styles.imagesBig} relative`}
                     style={{
                         paddingBottom: `${aspectRatio * 100}%`
                     }}
                >
                    <div className={`${styles.imagesWrap} absolute`}
                         style={{
                             paddingBottom: `${aspectRatio * 100}%`
                         }}
                    >
                        {/*type类型 0：图片， 1：视频 */}
                        {!!selectedItem?.picUrl
                            ? (
                                <ImageZoomViewer
                                    aspectRatio={aspectRatio}
                                    imgShowWidth={thumbImageSize}
                                    imgBigWidth={IMAGE_BIG_WIDTH}
                                    imgUrl={selectedItem.picUrl}
                                    alt={selectedItem?.altText}
                                    bigPicRef={bigPicRef}
                                />
                            )
                            : selectedItem?.videoUrl
                                ? (<VideoViewer
                                    className={'absolute'}
                                    src={`${selectedItem.videoUrl}?version=${Math.random()}`}
                                    visible
                                />)
                                : null
                        }
                    </div>
                </div>

                <ImagesListSwiper
                    imagesList={imagesList}
                    onClick={(e: IAsset) => {
                        onChangeShowImage(e)
                    }}
                />
            </div>
        </>
    )
}

export default React.memo(ImagesLightbox);
